module.exports = __webpack_public_path__ + "img/remove_clipboard.2acc91ad.svg";